import { atom } from 'recoil';
import { size } from "theme/breakpoints";

export const isMobileAtom = atom({
  key: 'isMobile',
  default: window.matchMedia(`(max-width: ${size.sm}px)`).matches,
  // @ts-ignore
  persistence_UNSTABLE: {
    type: 'log',
  },
});